import {Box, inputBaseClasses} from '@mui/material';
import InputBase from '@mui/material/InputBase';
import {styled} from '@mui/material/styles';
import {
  YSBackgroundState,
  YSBorderState,
  YSIconState,
  YSThemeStyleRadius,
} from 'main/utility/AppContextProvider/YSTheme';
import PropTypes from 'prop-types';

export const SearchWrapper = ({iconPosition, children, sx}) => {
  return (
    <Box
      sx={{
        borderRadius: 4, // Machined 4px
        display: 'block',
        cursor: 'pointer',
        // USE THE VARIABLE HERE:
        '& .searchRoot .MuiInputBase-input': {
          paddingLeft: iconPosition === 'right' ? 5 : 'calc(1em + 28px)',
          paddingRight: iconPosition === 'right' ? 'calc(1em + 28px)' : 5,
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

SearchWrapper.propTypes = {
  iconPosition: PropTypes.string,
  children: PropTypes.node,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]), // Add this validation
};

export const SearchInputBase = styled(InputBase)(({theme}) => ({
  [`& .${inputBaseClasses.root}`]: {
    width: '100%',
  },
  [`& .${inputBaseClasses.input}`]: {
    height: 36,
    borderRadius: YSThemeStyleRadius.SHARP,
    backgroundColor: YSBackgroundState.default,

    fontSize: 13,
    fontWeight: 600,
    letterSpacing: '0.05em', // Adds that professional "Label" look
    textTransform: 'none', // Keep lowercase for input, but use spacing

    color: theme.palette.text.primary,
    border: '1px solid',
    BorderColor: YSBorderState.default,
    boxSizing: 'border-box',
    transition: 'border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)',

    '&:focus': {
      borderColor: YSBorderState.focus,
      borderWidth: 1,
    },

    // 2. Refine the Placeholder
    '&::placeholder': {
      fontSize: '11px',
      textTransform: 'uppercase',
      letterSpacing: '0.15em', // Match the surgical feel of EXPORT
      opacity: 0.4, // Dial down for maximum "Visual Quiet"
    },
  },
}));

export const SearchIconBox = styled('div')((props) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  marginLeft: props.align === 'right' ? 'auto' : 0,

  '& .searchIconBox': {
    position: 'relative',
    '& $inputInput': {
      width: '100%',
      borderRadius: 4, // THE FIX: Change from 50 to 4
    },
  },
  // This ensures the focus border follows the 4px machined edge
  '&:focus-within': {
    '& .MuiInputBase-input': {
      border: `1px solid ${props.theme.palette.primary.main}`, // Yaman Gold
    },
  },
}));

export const SearchIconWrapper = styled('div')(({theme}) => ({
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 12,
  zIndex: 1,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  '& .MuiSvgIcon-root': {
    fontSize: 20, // Slightly smaller to match the refined text
    color: YSIconState.default,
  },

  '&.right': {
    left: 'auto',
    right: 12,
    '& + $inputRoot $inputInput': {
      paddingLeft: theme.spacing(5),
      paddingRight: `calc(1em + ${theme.spacing(7)})`,
    },
  },
}));
